import React from "react";
import {
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  useTranslate,
} from "react-admin";
import BackButton from "../components/BackButton";

// Custom field for GeoPoint
const GeoPointField = ({ source, record = {} }) => {
  const value = record[source];
  if (!value) return null;
  // Adjust property names if your GeoPoint uses 'latitude'/'longitude'
  const lat = value.lat ?? value.latitude;
  const lng = value.lng ?? value.longitude;
  if (lat === undefined || lng === undefined) return null;
  return (
    <span>
      {lat}, {lng}
    </span>
  );
};

export const getPois = (props) => {
  return (
    <List {...props} exporter={false} sort={{ field: "id", order: "DESC" }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="nom" />
        <TextField source="type" />
        <TextField source="adresse" />
        <TextField source="cp" />
        <TextField source="ville" />
        <TextField source="pays" />
        <TextField source="horaireSemaine" />
        <TextField source="horaireWeekEnd" />
        <GeoPointField source="location" />
        <TextField source="contact" />
        <TextField source="tel" />
        <TextField source="composition" />
        <TextField source="equipement" />
        <DateField source="createdAt" showTime />
        <DateField source="updatedAt" showTime />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
export const CustomForm = (props) => {
  const translate = useTranslate();
  return (
    <div className="w-100">
      <div className="d-flex flex-wrap">
        <div className="col-12 col-sm-6">
          <TextInput source="nom" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="type" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="adresse" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="cp" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="ville" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="pays" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="horaireSemaine" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="horaireWeekEnd" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="location.lat" label="Latitude" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="location.lng" label="Longitude" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="contact" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="tel" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="composition" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="equipement" fullWidth />
        </div>
      </div>
    </div>
  );
};

export const PoitsEdit = (props: any) => {
  const translate = useTranslate();
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <BackButton />
        <h3>{translate("pois.edit")}</h3>
        <b></b>
      </div>
      <Edit {...props}>
        <SimpleForm>
          <CustomForm />
        </SimpleForm>
      </Edit>
    </div>
  );
};
